import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Router } from '@angular/router';

import { AuthenticationService } from '../../services/authentication/authentication.service';
import { LoginModel } from '../../models/inModels/loginModel';

import { ShowHideInput } from "../../directives/show-hide.directive";
import { Message } from "primeng/components/common/message";

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
    model: LoginModel;
	show = false;
    loading = false;
    remeberMe = true;
	error: Message[];
    returnUrl: string;
    userExistsPrompt = false;
	@ViewChild(ShowHideInput) input: ShowHideInput;
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private route: ActivatedRoute
    ) { }

    ngOnInit() {
        // reset login status
        this.model = new LoginModel();
        this.authenticationService.logout();
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
	    let username = this.route.snapshot.queryParams['username'];
	    let password = this.route.snapshot.queryParams['password'];
	    if (username) {
		    this.model.username = username;
	    }
	    if (username && password ) {
		    this.model.username = username;
		    this.model.password = password;
		    this.login();
	    }
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model)
            .subscribe(
            result => {
                if (result) {
                    // login successful
                    this.router.navigate([this.returnUrl]);
                } else {
                    // login failed
	                this.error = [];
	                this.error.push({ severity: 'error', summary: 'Error', detail: "User Name or Password incorrect. Click <a href=\"/password/forgot/" + this.model.username + "\">here</a> to reset your password." });
				}
	            this.loading = false;
            },
            error => {
                // login failed
                console.log(error);
	            this.error = [];
	            this.error.push({ severity: 'error', summary: 'Error', detail: "User Name or Password incorrect. Click <a href=\"/password/forgot/" + this.model.username + "\">here</a> to reset your password." });
                this.loading = false;
            });
    }

    userExists(): void {
        if (this.model.username !== undefined && this.model.username !== "") {
	        this.authenticationService.userExist(this.model.username).then(
		        result => {
			        this.userExistsPrompt = !result;
		        }
	        );
        }
    }

	showPassword(event: any): void {
		this.show = true;
		this.changeType();
	}

	hidePassword(event: any): void {
		this.show = false;
		this.changeType();
	}

	changeType(): void {
		if (this.show) {
			this.input.changeType("text");
		}
		else {
			this.input.changeType("password");
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts